import React from "react";

// reactstrap components
import { Button, Table } from "reactstrap";
import NumberFormat from "react-number-format";

const formatDate = (value) => {
    if (!value) return "-";
    return new Date(value).toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
};

const STATUS_LABEL = {
    create: "Terbuka",
    proceed: "Selesai",
};

const StatusBadge = ({ status }) => (
    <span className={`badge badge-pill ${status === "proceed" ? "bg-gradient-success" : "bg-gradient-info"} text-white`}>
        {STATUS_LABEL[status] || status || "-"}
    </span>
);

class Shopping extends React.Component {
    render() {
        const shoppingList = this.props.shoppingList || [];

        return (
            <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                    <tr>
                        <th scope="col">Tanggal</th>
                        <th scope="col">Pembeli</th>
                        <th scope="col">Jumlah Item</th>
                        <th scope="col">Total Harga</th>
                        <th scope="col">Status</th>
                        <th scope="col">Aksi</th>
                    </tr>
                </thead>
                <tbody>
                    {shoppingList.length > 0 && shoppingList.filter((shopping) => shopping).map((shopping) => (
                        <tr key={shopping.Id}>
                            <th scope="row">{formatDate(shopping.ShoppingDate)}</th>
                            <td>{shopping.CreatorName}</td>
                            <td>{shopping.TotalItem}</td>
                            <td>
                                <NumberFormat
                                    value={shopping.TotalPrice}
                                    displayType="text"
                                    thousandSeparator
                                    prefix="Rp."
                                    suffix=",00"
                                />
                            </td>
                            <td>
                                <StatusBadge status={shopping.Status} />
                            </td>
                            <td>
                                <Button
                                    color="info"
                                    size="sm"
                                    className="mr-2"
                                    onClick={() => this.props.onPreview(shopping)}
                                >
                                    Lihat
                                </Button>
                                {shopping.Status !== "proceed" && (
                                    <Button
                                        color="primary"
                                        size="sm"
                                        className="mr-2"
                                        onClick={() => this.props.onEdit(shopping)}
                                    >
                                        Edit
                                    </Button>
                                )}
                                {shopping.Status !== "proceed" && (
                                    <Button
                                        color="warning"
                                        size="sm"
                                        onClick={() => this.props.onProceed(shopping)}
                                    >
                                        <i className="fas fa-arrow-circle-right mr-1" />
                                        Proses
                                    </Button>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        )
    };
}

export default Shopping;
